/**
 * 文本格式化工具函数
 */

/**
 * 转义HTML特殊字符，防止XSS攻击
 * @param {String} text - 需要转义的文本
 * @returns {String} 转义后的文本
 */
export function escapeHtml(text) {
  if (!text) return '';
  
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;'
  };
  
  return text.replace(/[&<>"'/]/g, (char) => map[char]);
}

/**
 * 高亮关键字
 * @param {String} text - 原始文本
 * @param {String} keyword - 关键字
 * @returns {String} 高亮后的HTML
 */
export function highlightKeyword(text, keyword) {
  if (!text || !keyword) return text;
  
  try {
    // 转义正则表达式特殊字符
    const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedKeyword})`, 'gi');
    return text.replace(regex, '<span style="font-weight:bold;color:red;">$1</span>');
  } catch (e) {
    console.error('关键字高亮失败:', e);
    return text;
  }
}

/**
 * 截断文本
 * @param {String} text - 原始文本
 * @param {Number} limit - 最大长度
 * @param {String} suffix - 后缀（默认为...）
 * @returns {String} 截断后的文本
 */
export function truncateText(text, limit = 20, suffix = '...') {
  if (!text) return '';
  if (text.length <= limit) return text;
  return text.substring(0, limit) + suffix;
}

/**
 * 替换HTML标签（处理代码块）
 * @param {String} text - 原始文本
 * @returns {String} 处理后的文本
 */
export function replaceHtmlTag(text) {
  if (!text) return '';
  
  // 匹配 @#@...#@# 格式的代码块
  const regTag = /@#@([\s\S]*?)#@#/g;
  const matches = text.match(regTag);
  
  if (matches) {
    matches.forEach(match => {
      const temp = match
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/@#@/g, '<pre><code>')
        .replace(/#@#/g, '</code></pre>');
      text = text.replace(match, temp);
    });
  }
  
  return text;
}

/**
 * 将换行符转换为<br/>标签
 * @param {String} text - 原始文本
 * @returns {String} 转换后的文本
 */
export function nl2br(text) {
  if (!text) return '';
  return text.replace(/\n/g, '<br/>');
}

/**
 * 格式化文本用于HTML展示（综合处理）
 * @param {String} text - 原始文本
 * @param {Object} options - 配置选项
 * @returns {String} 格式化后的HTML
 */
export function formatTextForHtml(text, options = {}) {
  const {
    keyword = '',
    limit = null,
    replaceTag = false
  } = options;
  
  if (!text) return '';
  
  let result = text;
  
  // 截断
  if (limit && limit > 0) {
    result = truncateText(result, limit, '...');
  }
  
  // 处理代码块
  if (replaceTag) {
    result = replaceHtmlTag(result);
  }
  
  // 关键字高亮
  if (keyword) {
    result = highlightKeyword(result, keyword);
  }
  
  // 换行转换
  result = nl2br(result);
  
  return result;
}

